var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoneyCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".money-coins_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "money-coins_svg__b",
    d: "M13.268 8.83a2.5 2.5 0 11-3.536 0 2.5 2.5 0 013.536 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "money-coins_svg__b",
    d: "M21 13.982V6.1a2 2 0 00-2-2H4a2 2 0 00-2 2v9a2 2 0 002 2h8.261M5 14.1h2M16 7.1h2M15.374 14.959a3.475 3.475 0 103.251 4.932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "money-coins_svg__b",
    d: "M18.521 19.9A3.479 3.479 0 1122 16.423a3.48 3.48 0 01-3.479 3.477"
  })));
}

export default SvgMoneyCoins;


//////////////////
// WEBPACK FOOTER
// ./src/icons/money-coins.svg
// module id = 459
// module chunks = 101